import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { addDays } from 'date-fns';
import axios from 'axios';
import './BookAppointment.css'; // Make sure to create this file

export default class BookAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientName: '',
      doctorName: 'Drsunil', // Default value
      departmentName: 'DepartOrthopedic', // Default value
      phoneNumber: '',
      symptoms: '',
      date: new Date(),
      time: new Date(),
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  }

  handleDateChange = (date) => {
    this.setState({ date });
  }

  handleTimeChange = (time) => {
    if (time) {
      this.setState({ time });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { patientName, phoneNumber, symptoms, date, time } = this.state;
    
    // Create a new date object to avoid mutating state directly
    const appointmentDateTime = new Date(date);
    appointmentDateTime.setHours(time.getHours(), time.getMinutes());
    
    const data = {
      patient_name: patientName,
      contact_number: phoneNumber,
      appointment_date: appointmentDateTime.toISOString().split('T')[0],
      appointment_time: appointmentDateTime.toISOString().split('T')[1].split('.')[0],
      reason: symptoms,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/appointments/`, data);
      console.log('Appointment Created:', response.data);
      alert('✅ Appointment Request Sent Successfully!');

      this.setState({
        patientName: '',
        phoneNumber: '',
        symptoms: '',
        date: new Date(),
        time: new Date(),
      });
    } catch (error) {
      console.error('Error creating appointment', error);
      alert('❌ Failed to book appointment. Please try again.');
    }
  }

  render() {
    const minDate = new Date();
    const maxDate = addDays(new Date(), 30); // Extended to 30 days
    
    const minTime = new Date();
    minTime.setHours(10, 0, 0, 0); 
    const maxTime = new Date();
    maxTime.setHours(18, 0, 0, 0);

    return (
      <section className="booking-section">
        <div className="container">
          <div className="booking-card">
            <div className="row g-0">
              
              {/* Left Side: Visual & Info */}
              <div className="col-lg-5 d-none d-lg-block">
                <div className="booking-sidebar">
                  <div className="sidebar-content">
                    <h3 className="sidebar-title">Book Your Visit</h3>
                    <p className="sidebar-text">
                      Schedule a consultation with Dr. Sunil Apsingi for expert orthopedic care.
                    </p>
                    
                    <div className="sidebar-info">
                      <div className="info-item">
                        <span className="icon">🏥</span>
                        <div>
                          <strong>Clinic Location</strong>
                          <p>Medicover Out Patient Center, HITEC City</p>
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="icon">📞</span>
                        <div>
                          <strong>Emergency Contact</strong>
                          <p>040-68334455</p>
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="icon">⏰</span>
                        <div>
                          <strong>Working Hours</strong>
                          <p>Mon - Sat: 10:00 AM - 04:00 PM</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side: The Form */}
              <div className="col-lg-7">
                <div className="booking-form-wrapper">
                  <h2 className="form-title">Patient Details</h2>
                  
                  <form onSubmit={this.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="patientName" className="form-label">Patient Name</label>
                        <input 
                          type="text" 
                          className="form-control-custom" 
                          id="patientName" 
                          value={this.state.patientName} 
                          onChange={this.handleChange} 
                          required
                          placeholder="Full Name"
                        />
                      </div>
                      
                      <div className="col-md-6 mb-3">
                        <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                        <input 
                          type="tel" 
                          className="form-control-custom" 
                          id="phoneNumber" 
                          value={this.state.phoneNumber} 
                          onChange={this.handleChange} 
                          required
                          placeholder="Mobile Number"
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Date</label>
                        <div className="date-picker-container">
                          <DatePicker
                            selected={this.state.date}
                            onChange={this.handleDateChange}
                            minDate={minDate}
                            maxDate={maxDate}
                            dateFormat="MMMM d, yyyy"
                            className="form-control-custom w-100"
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Time</label>
                        <div className="date-picker-container">
                          <DatePicker
                            selected={this.state.time}
                            onChange={this.handleTimeChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeFormat="HH:mm"
                            timeIntervals={30}
                            minTime={minTime}
                            maxTime={maxTime}
                            dateFormat="h:mm aa"
                            className="form-control-custom w-100"
                          />
                        </div>
                      </div>

                      <div className="col-12 mb-4">
                        <label htmlFor="symptoms" className="form-label">Reason for Visit</label>
                        <textarea 
                          className="form-control-custom" 
                          id="symptoms" 
                          rows="3"
                          placeholder="Briefly describe your pain or condition..." 
                          value={this.state.symptoms} 
                          onChange={this.handleChange} 
                        />
                      </div>

                      {/* Hidden Fields for Doctor/Dept (Since they are fixed) */}
                      <input type="hidden" id="doctorName" value={this.state.doctorName} />
                      <input type="hidden" id="departmentName" value={this.state.departmentName} />

                      <div className="col-12">
                        <button type="submit" className="btn btn-submit-custom w-100">
                          Confirm Appointment
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}